export const ORDER_GRID_CHANGE_COLUMNS = 'ORDER_GRID_CHANGE_COLUMNS';
export const orderGridChangeColumns = (statusViewId, filterViewId, columns) => {
  const statefulConfig = columns.map((c) => ({
    id: c.id,
    index: c.index,
    width: c.width,
    pinned: c.pinned,
    sorted: c.sorted,
    ...(c.shown === false ? { shown: false } : {}),
  }));
  return {
    columns: statefulConfig,
    filterViewId,
    statusViewId,
    type: ORDER_GRID_CHANGE_COLUMNS,
  };
};

export const ORDER_GRID_CHANGE_ORDERBY = 'ORDER_GRID_CHANGE_ORDERBY';
export const orderGridChangeOrderBy = (statusViewId, filterViewId, columns) => {
  const statefulConfig = columns.map((c) => ({
    id: c.id,
    index: c.index,
    width: c.width,
    pinned: c.pinned,
    sorted: c.sorted,
    ...(c.shown === false ? { shown: false } : {}),
  }));

  return {
    columns: statefulConfig,
    filterViewId,
    statusViewId,
    type: ORDER_GRID_CHANGE_ORDERBY,
  };
};

export const ORDER_GRID_CHANGE_PAGE = 'ORDER_GRID_CHANGE_PAGE';
export const orderGridChangePage = (newPage, pageSize) => ({
  newPage,
  pageSize,
  type: ORDER_GRID_CHANGE_PAGE,
});

export const ORDER_GRID_TOGGLE_SIDEBAR_VISIBILITY = 'ORDER_GRID_TOGGLE_SIDEBAR_VISIBILITY';
export const toggleSidebarVisibility = () => ({
  type: ORDER_GRID_TOGGLE_SIDEBAR_VISIBILITY,
});

export const ORDER_GRID_MANAGE_COLUMNS = 'ORDER_GRID_MANAGE_COLUMNS';
export const manageColumnConfiguration = () => ({
  type: ORDER_GRID_MANAGE_COLUMNS,
});

export const ORDER_GRID_SHOW_SPINNER = 'ORDER_GRID_SHOW_SPINNER';
export const showTheSpinnerOnOrderGrid = () => ({
  type: ORDER_GRID_SHOW_SPINNER,
});

export const ORDER_GRID_UPDATE_CUSTOM_CONFIGURATION = 'ORDER_GRID_UPDATE_CUSTOM_CONFIGURATION';
export const updateCustomViewGridConfiguration = (customViewColumnConfiguration) => ({
  type: ORDER_GRID_UPDATE_CUSTOM_CONFIGURATION,
  customViewColumnConfiguration,
});

export const SET_IS_LOADING = 'SET_IS_LOADING';
export const setIsLoading = (isLoading) => ({
  type: SET_IS_LOADING,
  isLoading,
});

export const ORDER_GRID_EXPAND_ROW = 'ORDER_GRID_EXPAND_ROW';
export const orderGridExpandRow = (fulfillmentPlanId) => ({
  type: ORDER_GRID_EXPAND_ROW,
  fulfillmentPlanId,
});

export const ORDER_GRID_SET_GROUPBYS = 'ORDER_GRID_SET_GROUPBYS';
export const orderGridSetGroupBys = (activeGroupBys) => ({
  type: ORDER_GRID_SET_GROUPBYS,
  activeGroupBys,
});

export const ORDER_GRID_SET_GROUPBYS_COUNT = 'ORDER_GRID_SET_GROUPBYS_COUNT';
export const orderGridSetGroupBysCount = (groupByCount) => ({
  type: ORDER_GRID_SET_GROUPBYS_COUNT,
  groupByCount,
});

export const SET_ORDER_GRID_IS_GROUPBYS_COUNT_LOADING = 'SET_ORDER_GRID_IS_GROUPBYS_COUNT_LOADING';
export const orderGridSetIsGroupBysCountLoading = (isGroupBysCountLoading) => ({
  type: SET_ORDER_GRID_IS_GROUPBYS_COUNT_LOADING,
  isGroupBysCountLoading,
});
